export enum RoundingType {
  None = 0,
  TenthFloor = 9,
  TenthNormal = 10,
  TenthCeiling = 11,
  OnesFloor = 99,
  OnesNormal = 100,
  OnesCeiling = 101
}
